const baseKey = '/v1/trader/balance'

export const traderBalanceAPI = {
  baseKey,
  transfer: `${baseKey}/transfer`,
}
